import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Apple from '../../../svg/Apple.js';
import Formsy from 'formsy-react';
import Checkbox from '../../form/Checkbox';

class Diet extends Component {
  state = {
    dietary_preference_tags: [],
    availableDiets: [],
    isCurrentStep: false
  };

  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const {
      availableDiets,
      dietary_preference_tags,
      isCurrentStep
    } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="Whats your diet like?"
          subline="Please let us know your general dietary restrictions."
          icon={<Apple />}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
          className="new-form onboarding-new__form"
        >
          <div className="row">
            <div className="row__item row__item--full">
              {availableDiets.length > 0 &&
                this.renderCheckboxes(
                  availableDiets,
                  dietary_preference_tags,
                  'dietary_preference_tags'
                )}
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  renderCheckboxes = (items, selectedItems, key) => {
    return items.map(item => (
      <div key={item.id}>
        <Checkbox
          name={item.tag}
          className="checkbox--large checkbox--large-blue checkbox--flex checkbox--short checkbox--onboarding"
          placeholder={item.tag}
          checked={this.isChecked(item, selectedItems)}
          onChange={e => this.toggleChecked(item, selectedItems, key)}
        />
      </div>
    ));
  };

  isChecked = (value, selectedItems = []) => {
    return selectedItems.findIndex(val => val.id === value.id) >= 0;
  };

  toggleChecked = (value, selectedItems = [], key) => {
    if (this.isChecked(value, selectedItems)) {
      // delete
      const index = selectedItems.findIndex(val => val.id === value.id);
      selectedItems = [
        ...selectedItems.slice(0, index),
        ...selectedItems.slice(index + 1, selectedItems.length)
      ];
    } else selectedItems = [...selectedItems, value];

    this.setState({
      [key]: selectedItems
    });
  };

  handleClientUpdate = () => {
    const { dietary_preference_tags } = this.state;

    const updatedClient = {
      dietary_preference_tags
    };
    this.props.updateClient(updatedClient);
  };

  componentDidUpdate(prevProps) {
    const {
      hasSubmitted,
      isCurrentStep = false,
      availableDiets,
      client
    } = this.props;
    const { dietary_preference_tags } = client;

    if (prevProps.client.dietary_preference_tags !== dietary_preference_tags)
      this.setState({ dietary_preference_tags });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (prevProps.availableDiets !== availableDiets)
      this.setState({ availableDiets });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }

  componentDidMount() {
    const { client, availableDiets } = this.props;
    const { dietary_preference_tags } = client;

    this.setState({ availableDiets, dietary_preference_tags });
  }
}

export default Diet;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Diet.js